import React from 'react';
import PropTypes from 'prop-types';
import { LuBug, LuFileSpreadsheet } from 'react-icons/lu';
import PageHero from '../../../components/data/PageHero';
import Button from '../../../components/ui/Button';
import useErrorReportText from '../errorReportText';

/** Title card of Çalışan Hata Geribildirimleri with the Excel download. */
const ErrorReportsHeader = ({ onExcel }) => {
  const { label } = useErrorReportText();
  return (
    <PageHero
      icon={LuBug}
      gradient="tw-from-rose-400 tw-to-pink-600 tw-shadow-rose-500/30"
      title={label('page.title')}
      subtitle={label('page.subtitle')}
      actionsClassName="tw-flex tw-items-center tw-gap-2 max-sm:tw-w-full"
    >
      <Button onClick={onExcel} title={label('actions.excelHint')} className="max-sm:tw-w-full">
        <LuFileSpreadsheet aria-hidden="true" className="tw-h-4 tw-w-4 tw-text-emerald-600 dark:tw-text-emerald-400" />
        {label('actions.excel')}
      </Button>
    </PageHero>
  );
};

ErrorReportsHeader.propTypes = { onExcel: PropTypes.func.isRequired };

export default ErrorReportsHeader;
